module.exports = __webpack_public_path__ + "img/about-customer.92a42203.png";